import actions from '../../store/actions'
import { useState } from 'react'
import { queries } from '../../resources'
import { generateError } from '../../helpers/errors'
import { CurrentSlateRequest, CurrentSlateResponse } from '../../resources/establishment/types'
import { useDispatch } from '../redux'

export const useGetCurrentSlate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const getCurrentSlate = (payload: CurrentSlateRequest): Promise<CurrentSlateResponse> => {
        setInProgress(true)
        return queries
            .getCurrentSlate(payload)
            .then((response) => {
                dispatch(actions.setCurrentSlate(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                throw generateError(error)
            })
    }

    return {
        getCurrentSlate,
        inProgress,
    }
}
